import { call } from "./api";

export const count = () => {
    return call(client => {
        return client.get(`/categories/count`);
    });
};

export const all = () => {
    return call(client => {
        return client.get(`/categories`, {
            params: { count: 0 }
        });
    });
};

export const search = params => {
    return call(client => {
        return client.get(`/categories`, params);
    });
};

export const add = params => {
    return call(client => {
        return client.post(`/categories`, params);
    });
};

export const edit = (id, params) => {
    return call(client => {
        return client.put(`/categories/${id}`, params);
    });
};

export const remove = (id, params) => {
    return call(client => {
        return client.delete(`/categories/${id}`, params);
    });
};

export const batchRemove = (ids, params) => {
    const promises = ids.map(id => {
        return call(client => {
            return client.delete(`/categories/${id}`, params);
        });
    });

    return Promise.all(promises);
};



// WEBPACK FOOTER //
// ./src/api/category.js